module.exports = __webpack_public_path__ + "img/showMore.97fea3a5.svg";